import firebase from "firebase/app";

const union = firebase.firestore.FieldValue.arrayUnion;
export const like = async (docId, currentUserId) => {
  await firebase
    .firestore()
    .collection("activities")
    .doc(docId)
    .update({
      likedByUsers: union(currentUserId),
    })
    .then(() => {
      console.info("Document successfully written");
    })
    .catch((e) => {
      console.error("Error liking activity", e);
    });
};
